import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { Link } from 'gatsby'
const GridImageText_2 = ({
  items,
  opacityValue,
  backgroundHexa,
  titleElement,
  titleHexa,
  paragraphHexa,
  paragraphColor,
  paragraphElement,
}: RealEstateDataPageComponentData) => {
  return (
    <section className="grid_image_text_2 p-y-config">
      <Container fluid>
        {' '}
        <Row>
          {items?.map((item, index) => (
            <Col
              lg={6}
              key={index}
            >
              <div className="item">
                <div className="content">
                  <ElementHTML
                    children={'0' + (index + 1) + '. ' + item.title}
                    className="title"
                    style={{ color: titleHexa || '#fff' }}
                    elementType={titleElement || 'h2'}
                  ></ElementHTML>
                  <div className="animation-content">
                    {item?.paragraph && (
                      <div className="mb-4 paragraph-container">
                        {item?.paragraph.split('\n').map((para, index) => (
                          <div
                            key={index}
                            className="d-block"
                          >
                            <ElementHTML
                              children={para || ''}
                              style={{ color: paragraphHexa || '#fff' }}
                              className={paragraphColor + ' paragraph-element '}
                              elementType={paragraphElement || 'p'}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    {item.value && (
                      <Link
                        className="btn btn-primary border"
                        to={item?.simbol!}
                      >
                        {item.value}
                      </Link>
                    )}
                  </div>
                </div>
                <div
                  className="opacity"
                  style={{
                    background: backgroundHexa || '#333',
                    opacity:
                      opacityValue && opacityValue !== '0'
                        ? Number(opacityValue) !== 100
                          ? `0.${Number(opacityValue)}`
                          : 1
                        : 0.6,
                  }}
                ></div>
                <Image
                  className=""
                  objectFit="cover"
                  alt="image-divisions"
                  image={item.image_gatsby!}
                ></Image>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default GridImageText_2
